<template>
    <div class="filter-data">
        <div v-for="(list,index) of categoryList" :key="index" class="category-name">
            <span data-qa="category-name">
                {{ list }}
            </span>

            <ds-icon-button
                data-qa="category-close"
                class="close-icon"
                name="x-circle-fill"
                @click="close(index)"
            />
        </div>

        <ds-dropdown
            ref="dropdown"
            disable-scroll
            position="bottom-end"
            data-qa="action-dropdown"
            :is-open="isActionDropdownOpen"
            @close="closeActions"
        >
            <template #default>
                <ds-outline-button
                    class="filter-button"
                    @click="toggleDropdownAction"
                >
                    <ds-icon name="filter" />
                    <span>Filter</span>
                </ds-outline-button>
            </template>

            <template #menu>
                <ul class="dropdown-menu-list">
                    <li class="dropdown-menu-item disabled">
                        Filter by category
                    </li>

                    <li
                        v-for="({ label, value }) in categoryDropdownOptions"
                        :key="value"
                        :class="['dropdown-menu-item', { selected: isSelectedValues(value)}]"
                        @click="selectedCategory(value)"
                    >
                        {{ label }}
                    </li>
                </ul>
            </template>
        </ds-dropdown>
    </div>
</template>

<script>
export default {
    props: {
        allReports: Array,
        reportType: String,
        uniqueCategoryValues: Array,
        isCentralizedReportingHubFeature: Boolean,
    },

    data() {
        return {
            isActionDropdownOpen: false,
            categoryList: [],
            allReportsCategory: [],
            reportsCategory: [],
            isFilteredData: false,
            uniqueCategory: [],
            reportTitle: this.reportType,
        };
    },

    computed: {
        categoryDropdownOptions() {
            this.loadCategories();

            return this.uniqueCategory?.map((categoryValue) => {
                return { label: categoryValue, value: categoryValue };
            });
        },

        filteredReportsList() {
            return this.isFilteredData ? this.reportsCategory : this.allReports;
        },

        filteredReportsCount() {
            return this.isFilteredData ? this.reportsCategory.length : this.allReports.length;
        },
    },

    methods: {
        loadCategories() {
            this.allReportsCategory = [];

            this.allReports?.forEach((report) => {
                if (this.isCentralizedReportingHubFeature && report.reportCategoryType === 'Order') {
                    this.allReportsCategory.push('Sales & Order');
                } else {
                    this.allReportsCategory.push(report.reportCategoryType);
                }
            });

            this.uniqueCategory = this.allReportsCategory.filter((category, index) => {
                return this.allReportsCategory.indexOf(category) === index;
            });
            this.uniqueCategory = this.uniqueCategory.sort();

            this.categoryFilter();
        },

        categoryFilter() {
            if (!this.isFilteredData) {
                this.categoryList = [];
                this.uniqueCategoryValues?.forEach((item) => {
                    if (this.reportTitle && this.categoryList.length >= 0) {
                        this.categoryList.push(item);
                    }
                });
            }
        },

        selectedCategory(selectedCategoryValues) {
            if (this.isCentralizedReportingHubFeature && selectedCategoryValues === 'Sales & Order') {
                this.categoryList.push('Order');
            } else {
                this.categoryList.push(selectedCategoryValues);
            }
            this.selectedReports();
        },

        close(categoryIndex) {
            this.categoryList?.splice(categoryIndex, 1);
            this.selectedReports();
            this.$emit('categoryLength', this.categoryList.length);
        },

        selectedReports() {
            this.categoryList = this.categoryList.filter((category, index) => {
                return this.categoryList.indexOf(category) === index;
            });
            this.reportsCategory = [];
            this.selectedCategoryList();
            this.$emit('filteredSavedReports', this.filteredReportsList, this.filteredReportsCount);
            this.$emit('allFilteredReports', this.categoryList, this.reportsCategory);
        },

        toggleDropdownAction() {
            this.isActionDropdownOpen = !this.isActionDropdownOpen;
        },

        closeActions() {
            this.isActionDropdownOpen = false;
        },

        isSelectedValues(value) {
            const val = (this.isCentralizedReportingHubFeature && value === 'Sales & Order') ? 'Order' : value;

            return this.categoryList.find((item) => item === val);
        },

        selectedCategoryList() {
            this.allReports?.forEach((report) => {
                this.categoryList?.forEach((listData) => {
                    if (report.reportCategoryType === listData) {
                        this.reportsCategory.push(report);
                    }
                });
            });

            if (this.categoryList.length) {
                this.isFilteredData = true;
            } else {
                this.isFilteredData = false;
            }
        },
    },
};

</script>

<style lang="scss">
.close-icon {
    padding: $spacing-100 0;

    .icon {
        height: 1rem;
        min-height: 0.5rem;
    }
}
</style>

<style lang="scss" scoped>
.filter-data {
    display: flex;
    align-items: center;
    .filter-button {
        justify-content: space-around;
        display: flex;
        span {
            margin-left: $spacing-100 ;
            font-size: $font-size-sm;
        }

        .icon {
            min-height: 1rem;
        }
    }

    .category-name {
        background: $color-gray-20;
        border-radius: px-to-rem(25px);
        padding-left: $spacing-200;
        width: auto;
        display: flex;
        align-items: center;
        margin-right: $spacing-200;

        span {
            font-size: $font-size-sm;
        }
    }
}
</style>
